exports.onClientEntry = () => {
  // eslint-disable-next-line global-require, import/no-extraneous-dependencies, import/no-unresolved
  require('core-js/actual/array/find-index');
  // eslint-disable-next-line global-require, import/no-extraneous-dependencies, import/no-unresolved
  require('core-js/actual/number');
  // eslint-disable-next-line global-require, import/no-extraneous-dependencies, import/no-unresolved
  require('core-js/actual/object/entries');
  // eslint-disable-next-line global-require, import/no-extraneous-dependencies, import/no-unresolved
  require('core-js/actual/string/starts-with');
};
